import { FileCogIcon } from 'lucide-react'

import { DocumentStatusBadge, useDocument } from '@/modules/documents'
import { DOCUMENT_STATUSES } from '@/modules/documents/constants'
import type { DocumentStatus } from '@/modules/documents/stores/types'

const descriptions: Partial<Record<DocumentStatus, string>> = {
  [DOCUMENT_STATUSES.enqueued]:
    'Your document is queued and will start processing shortly.',
  [DOCUMENT_STATUSES.recognizing]:
    'Extracting text and content from your document.',
  [DOCUMENT_STATUSES.indexing]: 'Building the search index for your document.',
}

export const DocumentProcessing = () => {
  const document = useDocument()
  if (!document) return null

  const description = descriptions[document.status]

  return (
    <div
      aria-live="polite"
      className="flex flex-1 self-start flex-col items-center justify-center gap-4 rounded-lg border py-24 text-center bg-white"
    >
      <div className="rounded-full bg-blue-50 p-4">
        <FileCogIcon className="size-8 text-blue-700" />
      </div>
      <div className="space-y-2">
        <h3 className="text-lg font-semibold">Processing document</h3>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      <DocumentStatusBadge status={document.status} />
    </div>
  )
}
